import React from "react";
import Portfolio from "./Portfolio";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
